import { useTranslation } from 'react-i18next';

const faqs = [
  {
    sectionKey: 'faq_generalTitle',
    taglineKey: 'faq_generalTagline',
    items: [
      { q: 'faq_general_q1', a: 'faq_general_a1' },
      { q: 'faq_general_q2', a: 'faq_general_a2' },
      { q: 'faq_general_q3', a: 'faq_general_a3' },
      { q: 'faq_general_q4', a: 'faq_general_a4' },
      { q: 'faq_general_q5', a: 'faq_general_a5' },
    ],
  },
  {
    sectionKey: 'faq_clientsTitle',
    taglineKey: 'faq_clientsTagline',
    items: [
      { q: 'faq_clients_q1', a: 'faq_clients_a1' },
      { q: 'faq_clients_q2', a: 'faq_clients_a2' },
      { q: 'faq_clients_q3', a: 'faq_clients_a3' },
      { q: 'faq_clients_q4', a: 'faq_clients_a4' },
      { q: 'faq_clients_q5', a: 'faq_clients_a5' },
      { q: 'faq_clients_q6', a: 'faq_clients_a6' },
      { q: 'faq_clients_q7', a: 'faq_clients_a7' },
    ],
  },
  {
    sectionKey: 'faq_providersTitle',
    taglineKey: 'faq_providersTagline',
    items: [
      { q: 'faq_providers_q1', a: 'faq_providers_a1' },
      { q: 'faq_providers_q2', a: 'faq_providers_a2' },
      { q: 'faq_providers_q3', a: 'faq_providers_a3' },
      { q: 'faq_providers_q4', a: 'faq_providers_a4' },
      { q: 'faq_providers_q5', a: 'faq_providers_a5' },
      { q: 'faq_providers_q6', a: 'faq_providers_a6' },
      { q: 'faq_providers_q7', a: 'faq_providers_a7' },
      { q: 'faq_providers_q8', a: 'faq_providers_a8' },
      { q: 'faq_providers_q9', a: 'faq_providers_a9' },
    ],
  },
];

const FAQs = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-home">
      <header className="bg-darkBlue text-white mb-5">
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-12 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
            {t('faq_pageTitle')}
          </h1>
          <p className="mt-4 text-xl font-normal text-indigo-100 max-w-3xl mx-auto not-italic">
            {t('faq_subtitle')}
          </p>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-4 pb-14 sm:px-6 lg:px-8 space-y-12">
        {faqs.map((section) => (
          <section key={section.sectionKey} className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-8">
            <div className="mb-6">
              <h2 className="text-3xl font-bold text-[#4285F4]">
                {t(section.sectionKey)}
              </h2>
              <p className="mt-2 text-base font-normal text-[#555555] not-italic">
                {t(section.taglineKey)}
              </p>
            </div>

            <div className="space-y-6">
              {section.items.map((item) => (
                <article key={item.q} className="space-y-2">
                  <h3 className="text-lg font-bold text-[#000000]">
                    {t(item.q)}
                  </h3>
                  <p className="text-[#555555] font-normal leading-relaxed">{t(item.a)}</p>
                </article>
              ))}
            </div>
          </section>
        ))}

        <section className="text-center py-2">
          <h3 className="text-2xl font-bold text-[#4285F4]">{t('faq_contactTitle')}</h3>
          <p className="mt-3 text-base font-normal text-[#555555]">{t('faq_contactLine')}</p>
        </section>
      </div>
    </div>
  );
};

export default FAQs;